export const AGENT_NAME_URL = '/api/c-agentservice/v1/agent-titles/';
export const LEAD_SOURCES_URL = '/api/leadsourceservice/public/v1/lead-sources';
